import { AxiosResponse } from "axios";
import Cookies from "js-cookie";
import { DEFAULT_PAGE_LIMIT, endpoints } from "../constants/api";
import { $http } from "../config/axiosConfig";
import {
  CreateSharedUrlPayload,
  CreateSharedUrlResponse,
  SharedUrlListResponse,
  SharedViewResponse,
  SharedMeterReadingsResponse,
} from "../types";

export type ReportDownloadLogPayload = {
  meterSerialNo: string;
  reportType: "daily" | "monthly" | "shared-readings";
  format: "pdf" | "csv";
  sharedToken?: string;
};

export const logReportDownloadAsync = async (payload: ReportDownloadLogPayload): Promise<void> => {
  try {
    await $http.post(endpoints.reportDownloadLog, payload);
  } catch {
    // Logging failure should never block the user's download
  }
};

// Protected endpoints (require auth)

export const createSharedUrlAsync = async (
  payload: CreateSharedUrlPayload
): Promise<CreateSharedUrlResponse | any> => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse<CreateSharedUrlResponse> = await $http.post(
      endpoints.sharedUrl,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchSharedUrlsAsync = async (): Promise<
  SharedUrlListResponse | any
> => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse<SharedUrlListResponse> = await $http.get(
      endpoints.sharedUrl,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const revokeSharedUrlAsync = async (
  id: string
): Promise<{ message: string } | any> => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.delete(
      `${endpoints.sharedUrl}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

// Public endpoints (no auth required)

export const fetchSharedViewAsync = async (
  shareToken: string
): Promise<SharedViewResponse | any> => {
  try {
    const data: AxiosResponse<SharedViewResponse> = await $http.get(
      `${endpoints.sharedView}/${shareToken}`
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchSharedMeterReadingsAsync = async (
  shareToken: string,
  meterId: number,
  page = 1,
  limit = DEFAULT_PAGE_LIMIT
): Promise<SharedMeterReadingsResponse | any> => {
  try {
    const data: AxiosResponse<SharedMeterReadingsResponse> = await $http.get(
      `${endpoints.sharedView}/${shareToken}/meter/${meterId}/readings?page=${page}&limit=${limit}`
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchSharedMeterBarGraphAsync = async (
  shareToken: string,
  meterId: number
): Promise<any> => {
  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.sharedView}/${shareToken}/meter/${meterId}/bargraph`
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};
